<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col cols="12" xl="12">
                <transition name="slide">
                    <b-card>
                        <div slot="header">
                            <div class="card-header-actions">
                            <b-link class="card-header-action btn-setting" to="create" :append="true">
                                <i class="icon-plus"></i>
                            </b-link>
                            </div>
                        </div>
                        <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" @row-clicked="rowClicked">
                            <template v-slot:cell(is_active)="data">
                                <b-badge variant="success" v-if="data.item.is_active">{{ $t('active') }}</b-badge>
                                <b-badge variant="primary" v-else>{{ $t('notActive') }}</b-badge>
                            </template>
                        </b-table>
                    </b-card>
                </transition>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    name: "Projects",
    props: {
        caption: {
        type: String,
        default: 'Projects'
        },
        hover: {
        type: Boolean,
        default: true
        },
        striped: {
        type: Boolean,
        default: true
        },
        bordered: {
        type: Boolean,
        default: false
        },
        small: {
        type: Boolean,
        default: false
        },
        fixed: {
        type: Boolean,
        default: false
        }
    },
    data: function() {
        return {
            fields: [
                {
                    key: "title",
                    label: this.$t('title'),
                    sortable: true
                },
                {
                    key: "is_active",
                    label: this.$t('isActive'),
                    sortable: true
                },
            ],
            currentPage: 1,
            perPage: 20,
            totalRows: 0
        }
    },
    methods: {
        rowClicked(item) {
            const link = "/admin/widgets/edit/" + item.uuid
            this.$router.push({path: link})
        }
    },
    computed: {
        items() {
            return this.$store.getters.widgets
        }
    }
}
</script>
